import { CacheStrategy } from '@rammetec/data-access';
import { AUDIT_FIELD_DESCRIPTORS, AUDIT_FOREIGN_KEYS } from './_auditFields.js';
import { LIFECYCLE_FIELD_DESCRIPTORS } from './_lifecycleFields.js';
import { BUSINESS_ALLOWED_DATA_SOURCES, BUSINESS_DEFAULT_DATA_SOURCE } from './dataSourcePolicy.js';
import { MACHINE } from '../types/machine.js';
import { WORK_CALENDAR } from '../types/work-calendar.js';
import { FIELD_LIMITS } from '../validation/fieldLimits.js';
/**
 * Descriptor for Machine entity.
 * Stored in 'org/{orgId}/machine'.
 */
export const machineDescriptor = {
    name: MACHINE,
    label: 'Máquina',
    domain: 'catalog',
    collectionPath: 'org/{orgId}/machine',
    pathPatternKeys: {
        orgId: 'string',
    },
    version: 2,
    description: 'Machine that defines production batch and influences input consumption',
    repositoryConfig: {
        dataSource: BUSINESS_DEFAULT_DATA_SOURCE,
        cache: CacheStrategy.InMemory,
    },
    allowedDataSources: BUSINESS_ALLOWED_DATA_SOURCES,
    fields: [
        {
            name: 'id',
            label: 'ID',
            type: 'string',
            required: true,
            description: 'Unique machine identifier',
        },
        {
            name: 'code',
            example: 3,
            label: 'Código',
            type: 'number',
            display: 'code',
            required: true,
            unique: true,
            autoNumber: true,
            description: 'Numeric machine code (master-data identifier; non-negative, capped at MAX_CODE_SMALL)',
        },
        {
            name: 'description',
            example: 'Jet 03',
            label: 'Descrição',
            type: 'string',
            required: true,
            maxLength: FIELD_LIMITS.NAME,
            description: 'Machine description',
        },
        {
            name: 'productionBatch',
            example: 50,
            label: 'Lote de produção',
            type: 'number',
            display: 'code',
            required: true,
            description: 'Production batch quantity (non-negative, capped at MAX_QUANTITY)',
        },
        {
            name: 'sectorId',
            label: 'Setor',
            type: 'string',
            required: true,
            description: 'Reference to the sector this machine belongs to',
        },
        {
            name: 'machineGroupId',
            label: 'Grupo de máquinas',
            type: 'string',
            required: false,
            description: 'Reference to the machine group this machine belongs to',
        },
        {
            name: 'workCalendarId',
            label: 'Calendário de trabalho',
            type: 'string',
            required: false,
            description: 'Optional work calendar (overrides the sector/factory calendar for this machine)',
        },
        ...LIFECYCLE_FIELD_DESCRIPTORS,
        ...AUDIT_FIELD_DESCRIPTORS,
    ],
    foreignKeys: [
        ...AUDIT_FOREIGN_KEYS,
        {
            fieldName: 'sectorId',
            targetEntity: 'Sector',
            relationship: 'many-to-one',
            description: 'The sector this machine belongs to',
            displayField: 'description',
        },
        {
            fieldName: 'machineGroupId',
            targetEntity: 'MachineGroup',
            relationship: 'many-to-one',
            description: 'The machine group this machine belongs to',
            displayField: 'description',
        },
        {
            fieldName: 'workCalendarId',
            targetEntity: WORK_CALENDAR,
            relationship: 'many-to-one',
            displayField: 'description',
            description: 'Optional work calendar for this machine',
        },
    ],
};
//# sourceMappingURL=machine.descriptor.js.map